// src/api/leadAPI.js - WITH DEBUG LOGGING
import axiosInstance from './axiosConfig';

const leadAPI = {
  // Get all leads (filtered by user's department access)
  getLeads: async () => {
    try {
      console.log('🔍 [API] Fetching leads...');
      const response = await axiosInstance.get('/leads');
      console.log('✅ [API] Leads response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [API] Failed to fetch leads:', error);
      throw error.response?.data || { message: 'Failed to fetch leads' };
    }
  },

  // Get lead by ID
  getLeadById: async (id) => {
    try {
      const response = await axiosInstance.get(`/leads/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch lead' };
    }
  },

  // Create new lead
  createLead: async (leadData) => {
    try {
      console.log('🚀 [API] Creating lead:', leadData);
      const response = await axiosInstance.post('/leads', leadData);
      console.log('✅ [API] Lead created:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [API] Failed to create lead:', error.response?.data);
      throw error.response?.data || { message: 'Failed to create lead' };
    }
  },

  // Update lead
  updateLead: async (id, leadData) => {
    try {
      const response = await axiosInstance.put(`/leads/${id}`, leadData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update lead' };
    }
  },

  // Delete lead
  deleteLead: async (id) => {
    try {
      const response = await axiosInstance.delete(`/leads/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete lead' };
    }
  },

  // Paginated leads list with optional filters.
  // Returns { rows, total, page, limit }
  getLeadsPaginated: async ({
    page = 1, limit = 50,
    q, status, assigned_to, department_id
  } = {}) => {
    try {
      const params = { page, limit };
      if (q)              params.q             = q;
      if (status)         params.status        = status;
      if (assigned_to)    params.assigned_to   = assigned_to;
      if (department_id)  params.department_id = department_id;
      const response = await axiosInstance.get('/leads/paginated', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch leads' };
    }
  },

  // Get lead statistics
  // range: { from, to } as YYYY-MM-DD, both optional and both inclusive.
  // The one place won/conversion are calculated, shared with the Flutter app so
  // web and mobile cannot drift apart on what "won" means.
  getDashboardStats: async () => {
    const response = await axiosInstance.get('/leads/dashboard-stats');
    return response.data;
  },

  getLeadStats: async (range = {}) => {
    try {
      const response = await axiosInstance.get('/leads/stats', { params: range });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch lead statistics' };
    }
  }
};

export default leadAPI;